export { PhoneModule } from './phone.module';
export { formatPhone } from './utils';
export { inputPhoneValidator, inputPhoneFormValidator } from './components';
